module.exports = __webpack_public_path__ + "static/media/souls@768.473d2144.png";